{
  "major": 7,
  "minor": 5,
  "patch": 5,
  "build": 5,
  "notes": "",
  "date": ""
}
